import { STRINGS } from '../constants/strings';
import { LANG, ELEMENT, COLOR, PATH_LOCATION } from '../constants/constants';
import { THEMES } from '../constants/themes';

// export const processQuery = (queryString) => {
//   const params = {};
//   let temp;
//   let i;
//   let l;
//   const queries = queryString.split('&');
//   for (i = 0, l = queries.length; i < l; i++) {
//     temp = queries[i].split('=');
//     params[temp[0]] = temp[1];
//   }
//   return params;
// }

export const isAndroid = () => {
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    return true;
  }
  return false;
}

export const isIOS = () => {
  if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)) {
    return true;
  }
  return false;
}

// export const getStatusText = (status, lang) => {
//   console.log(status);
//   switch (status) {
//     case STATUS.ACTIVE:
//       return STRINGS[lang].active;
//     case STATUS.PENDING:
//       return STRINGS[lang].pending;
//     case STATUS.PAYMENT_FAIL:
//     case STATUS.FAIL:
//       return STRINGS[lang].fail;
//     default:
//       return '';
//   }
// }

export const tableColor = (tableType) => {
  switch (tableType) {
    case 'B':
    case 'H':
    case 'N':
    case 'T':
    case 'Z':
      return 'B'
    case 'C':
    case 'I':
    case 'O':
    case 'U':
      return 'C'
    case 'D':
    case 'J':
    case 'P':
    case 'V':
      return 'D'
    case 'E':
    case 'K':
    case 'Q':
    case 'W':
      return 'E'
    case 'F':
    case 'L':
    case 'R':
    case 'X':
      return 'F'
    default:
      return 'A'
  };
}

export const getTableColorByIndex = (index) => {
  const tempIndex = Number(index);
  const tableColor = ['A', 'B', 'C', 'D', 'E', 'F'];
  if (!isNaN(tempIndex)) {
    return tableColor[tempIndex % 6];
  }
  return tableColor[0];
}

export const validateEmail = (email) => {
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)(\.[a-zA-Z0-9-]+){0,1}$/i.test(email);
}

export const validateMobile = (mobile) => {
  return /^[0-9]+$/i.test(mobile);
}

export const getStringByTheme = (key, lang = LANG.TC, theme) => {
  switch (theme) {
    case THEMES.TB_RED_ORANGE:
      switch (lang) {
        case LANG.EN:
          return (STRINGS[LANG.EN_TB][key]) ? STRINGS[LANG.EN_TB][key] : STRINGS[lang][key];
        case LANG.SC:
          return (STRINGS[LANG.SC_TB][key]) ? STRINGS[LANG.SC_TB][key] : STRINGS[lang][key];
        default:
          return (STRINGS[LANG.TC_TB][key]) ? STRINGS[LANG.TC_TB][key] : STRINGS[lang][key];
      }
    case THEMES.TESTING_CENTRE:
      switch (lang) {
        case LANG.EN:
          return (STRINGS[LANG.EN_TESTING_CENTRE][key]) ? STRINGS[LANG.EN_TESTING_CENTRE][key] : STRINGS[lang][key];
        case LANG.SC:
          return (STRINGS[LANG.SC_TESTING_CENTRE][key]) ? STRINGS[LANG.SC_TESTING_CENTRE][key] : STRINGS[lang][key];
        default:
          return (STRINGS[LANG.TC_TESTING_CENTRE][key]) ? STRINGS[LANG.TC_TESTING_CENTRE][key] : STRINGS[lang][key];
      }
    case THEMES.MTR_TAXI:
      switch (lang) {
        case LANG.EN:
          return (STRINGS[LANG.EN_MTR_TAXI][key]) ? STRINGS[LANG.EN_MTR_TAXI][key] : STRINGS[lang][key];
        case LANG.SC:
          return (STRINGS[LANG.SC_MTR_TAXI][key]) ? STRINGS[LANG.SC_MTR_TAXI][key] : STRINGS[lang][key];
        default:
          return (STRINGS[LANG.TC_MTR_TAXI][key]) ? STRINGS[LANG.TC_MTR_TAXI][key] : STRINGS[lang][key];
      }
    case THEMES.COUNTER:
      switch (lang) {
        case LANG.EN:
          return (STRINGS[LANG.EN_COUNTER][key]) ? STRINGS[LANG.EN_COUNTER][key] : STRINGS[lang][key];
        case LANG.SC:
          return (STRINGS[LANG.SC_COUNTER][key]) ? STRINGS[LANG.SC_COUNTER][key] : STRINGS[lang][key];
        default:
          return (STRINGS[LANG.TC_COUNTER][key]) ? STRINGS[LANG.TC_COUNTER][key] : STRINGS[lang][key];
      }
    case THEMES.LEAVE_HOME_SAFE:
      switch (lang) {
        case LANG.EN:
          return (STRINGS[LANG.EN_LEAVE_HOME_SAFE][key]) ? STRINGS[LANG.EN_LEAVE_HOME_SAFE][key] : STRINGS[lang][key];
        case LANG.SC:
          return (STRINGS[LANG.SC_LEAVE_HOME_SAFE][key]) ? STRINGS[LANG.SC_LEAVE_HOME_SAFE][key] : STRINGS[lang][key];
        default:
          return (STRINGS[LANG.TC_LEAVE_HOME_SAFE][key]) ? STRINGS[LANG.TC_LEAVE_HOME_SAFE][key] : STRINGS[lang][key];
      }
    default:
      return STRINGS[lang][key];
  }
}

export const showElementByTheme = (element, theme) => {
  switch (element) {
    case ELEMENT.PROMOTION_TNC:
      switch (theme) {
        case THEMES.TB_RED_ORANGE:
        case THEMES.TESTING_CENTRE:
        case THEMES.LEAVE_HOME_SAFE:
        case THEMES.MTR_TAXI:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_LIST_LOGO:
      switch(theme) {
        case THEMES.LEAVE_HOME_SAFE:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_QUEUE_TITLE:
      switch (theme) {
        case THEMES.TESTING_CENTRE:
        case THEMES.LEAVE_HOME_SAFE:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_BANNER_LIST:
      switch (theme) {
        case THEMES.TESTING_CENTRE:
        case THEMES.LEAVE_HOME_SAFE:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_NAVIGATION_LIST_TOP:
      switch (theme) {
        case THEMES.MTR_TAXI:
          return true;
        default:
          return false;
      }
    case ELEMENT.SITE_DETAIL_NAVIGATION_LIST_BOTTOM:
      switch (theme) {
        case THEMES.TESTING_CENTRE:
        case THEMES.LEAVE_HOME_SAFE:
          return true;
        default:
          return false;
      }
    case ELEMENT.SITE_DETAIL_BOTTOM_BUTTON:
      switch (theme) {
        case THEMES.TESTING_CENTRE:
        case THEMES.LEAVE_HOME_SAFE:
        case THEMES.MTR_TAXI:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_NAV_PRE_REG_ICON:
      switch (theme) {
        case THEMES.MTR_TAXI:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_NAV_QRCODE_ICON:
      switch (theme) {
        case THEMES.MTR_TAXI:
          return true;
        default:
          return false;
      }
    case ELEMENT.SITE_DETAIL_MOBILE_QUEUE:
      switch (theme) {
        case THEMES.MTR_TAXI:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_INFO_SITE_LOGO:
      switch (theme) {
        case THEMES.TB_RED_ORANGE:
        case THEMES.LEAVE_HOME_SAFE:
          return false;
        default:
          return true;
      }

    case ELEMENT.SITE_INFO_SITE_DATE:
      switch (theme) {
        case THEMES.LEAVE_HOME_SAFE:
          return true;
        default:
          return false;
      }

    case ELEMENT.TAG_SEQUENCE_CALL_LOGO:
      switch (theme) {
        case THEMES.MTR_TAXI:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_TAG_SEQUENCE_LIST:
      switch (theme) {
        case THEMES.COUNTER:
          return false;
        default:
          return true;
      }
    case ELEMENT.SITE_DETAIL_COUNTER_TAG_LIST:
      switch (theme) {
        case THEMES.COUNTER:
          return true;
        default:
          return false;
      }
    case ELEMENT.TICKET_DETAIL_BGCOLOR:
      switch (theme) {
        case THEMES.LEAVE_HOME_SAFE:
          return false;
        default:
          return true;
      }
    default:
      return true;
  }
}

export const getStrokeColor = (pathLocation, theme) => {
  switch (pathLocation) {
    case PATH_LOCATION.SITE_DETAIL:
      switch (theme) {
        case THEMES.LEAVE_HOME_SAFE:
          return COLOR.BLACK;
        default:
          return COLOR.WHITE;
      }
    case PATH_LOCATION.TICKET:
      switch (theme) {
        case THEMES.LEAVE_HOME_SAFE:
          return COLOR.BLACK;
        default:
          return COLOR.WHITE;
      }
    case PATH_LOCATION.SITE_DETAIL_MAP:
      switch (theme) {
        case THEMES.LEAVE_HOME_SAFE:
          return COLOR.LEAVE_HOME_SAFE_YELLOW;
        default:
          return COLOR.WHITE;
      }
    default:
      return COLOR.WHITE;
  }
}